import Types from "./Types";

const INITIAL_STATE = {
  officeHours: [],
  isLoading: false,
  count: 0,
};

function normalizeList(payload) {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.data?.data)) return payload.data.data;
  return [];
}

export default function officeHoursReducer(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case Types.GET_OFFICE_HOURS_SUCCESS: {
      const list = normalizeList(payload);
      return {
        ...state,
        officeHours: list,
        count: list.length,
      };
    }

    case Types.CREATE_OFFICE_HOUR_SUCCESS: {
      const row = payload?.data?.data ?? payload?.data ?? payload;
      if (!row || row.id == null) return state;
      const officeHours = [...state.officeHours, row];
      return {
        ...state,
        officeHours,
        count: officeHours.length,
      };
    }

    case Types.UPDATE_OFFICE_HOUR_SUCCESS: {
      const row = payload?.data ?? payload;
      if (!row || row.id == null) return state;
      const next = state.officeHours.map((item) =>
        String(item.id) === String(row.id) ? { ...item, ...row } : item
      );
      return { ...state, officeHours: next };
    }

    case Types.DELETE_OFFICE_HOUR_SUCCESS: {
      const id = payload;
      const next = state.officeHours.filter(
        (item) => String(item.id) !== String(id)
      );
      return { ...state, officeHours: next, count: next.length };
    }

    case Types.OFFICE_HOURS_LOADING: {
      return { ...state, isLoading: payload };
    }

    default:
      return state;
  }
}
